<template>
  <div>
    <v-list-tile>
      <v-subheader class="text-xs-center text-no-wrap text-truncate">#{{ item.cod }} - {{ item.causale }}</v-subheader>
      <v-spacer/>
      <v-list-tile-action style="min-width: auto;">
        <v-chip 
          v-if="item.firma" 
          color="green" 
          text-color="white" 
          disabled 
          small>
          <v-avatar>
            <v-icon>check_circle</v-icon>
          </v-avatar>FIRMATO
        </v-chip>
        <v-menu
          v-if="!item.firma"
          v-model="menu"
          :close-on-content-click="false"
          :nudge-width="200"
          offset-x
        >
          <v-chip 
            slot="activator" 
            color="#48586e" 
            text-color="white" 
            small>
            <v-avatar>
              <v-icon>edit</v-icon>
            </v-avatar>FIRMA ...
          </v-chip>

          <v-card>
            <v-list>
              <v-list-tile avatar>
                <v-list-tile-avatar>
                  <v-icon 
                    slot="badge" 
                    medium>done_all</v-icon>
                </v-list-tile-avatar>

                <v-list-tile-content>
                  <v-list-tile-title>Firma la nota #{{ item.cod }}</v-list-tile-title>
                  <v-list-tile-sub-title>Inserisci la password da portale</v-list-tile-sub-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list>
            <v-divider/>
            <v-layout 
              row 
              wrap 
              style="align-items:center">
              <input 
                style="display:none" 
                type="password" 
                name="fakepasswordremembered">
              <v-text-field
                v-model="codice"
                style="margin-left: 20px"
                color="tree"
                label="Password"
                required
                type="password"
                autofocus
                browser-autocomplete="off"
              />
            </v-layout>
            <v-card-actions>
              <v-spacer/>
              <v-btn 
                flat 
                @click="menu = false">Cancella</v-btn>
              <v-btn 
                flat 
                @click="firmaNota(codice, item)">Firma</v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-list-tile-action>
    </v-list-tile>
    <v-list 
      one-line 
      class="swipe-card">
      <swipe-list
        ref="list"
        :items="item.note"
        :disabled="true"        
        item-key="id"
      >
        <template v-slot="{ item, index }">
          <v-flex 
            :style="item.stato == 0 || item.stato == 3 ? 'cursor: pointer' : ''"
            class="pa-0" 
            @click="swipeClickHandler(index, item)">
            <CardNotaItem 
              :item="item"
              :key="index"
            />  
          </v-flex>
        </template>

        <template 
          v-slot:left="{ item }" >
          <div class="swipeout-action swipeoutright" >
            <v-btn 
              depressed 
              class="swap__btn"
              ripple 
              color="warning" 
              @click="getNota(item.id)">
              <v-icon 
                size="16" 
                color="white" >create</v-icon>              
            </v-btn>
          </div>
          <div class="swipeout-action swipeoutleft" >
            <v-btn 
              depressed 
              class="swap__btn"
              ripple 
              color="red" 
              @click="removeNoteSpesa(item.id)">
              <v-icon 
                size="16" 
                color="white">fas fa-times</v-icon>
            </v-btn>
          </div>
        </template>
      </swipe-list>
    </v-list>
    <CambiaNota
      v-if="nota.dettaglio"
      :nota="nota"
      :mod-nota="modNota"
      :mese="mese"
      :id-richiesta="item.cod"
      @onClose="onCloseHandler"
    />
  </div>
</template>
<script>
import CardNotaItem from "./CardNotaItem.vue";
import CambiaNota from "./CambiaNota.vue";
import SwipeList from "./SwipeList";
import SwipeOut from "./SwipeOut";

export default {
  name: "AccCardNota",
  components: {
    SwipeList,
    SwipeOut,
    CardNotaItem,
    CambiaNota
  },
  props: {
    item: {
      type: Object,
      required: true
    },
    mese: {
      type: String,
      required: true
    }
  },
  data: () => ({
    menu: false,
    codice: null,
    modNota: false,
  }),
  computed: {
    nota() {
      return this.$store.getters["notaSpese/nota"];
    }
  },
  watch: {
      menu (val) {
          if(val) {
              this.codice = null
            }
      }
  },
  methods: {
      firmaNota(codice, id_richiesta) {
          this.$store
              .dispatch("notaSpese/firmaNota", {
                  codice: codice,
                  id_richiesta: id_richiesta.cod,
                  mese: this.mese
              })
              .then(() => {
                  this.menu = false;
              });
      },
      getNota(idNota) {
          this.$store
              .dispatch("notaSpese/getNota", {idNota: idNota})
              .then(() => {
                  this.modNota = true;
              });
      },
      onCloseHandler() {
          this.modNota = false;
      },
      reinviaCodice(item) {
          var id_richiesta = item.cod;
          this.$store
              .dispatch("notaSpese/reinviaCodice", {id_richiesta: id_richiesta});
      },
      removeNoteSpesa(idNota) {
          this.$swal({
                  html:
                      `Sicuro di voler eliminare la nota?`,
                  showCancelButton: true,
                  confirmButtonText: "Elimina",
                  cancelButtonText: "Annulla",
                  allowOutsideClick: () => !this.$swal.isLoading()
              })
              .then(result => {
                  if (result.value) {
                      this.$store
                          .dispatch("notaSpese/removeNotaSpesa", {id_nota: idNota, mese: this.mese});
                  } else {
                      return false;
                  }
              });
      },
      swipeClickHandler(index, item) {
        if (item.stato == 0 || item.stato == 3)
          this.$refs.list.revealLeft(index);
      }
  }
};
</script>

<style scoped lang="scss">
.swipe-card {
  &.v-list {
    padding: 0;
  }
}
.swipeoutleft, .swipeoutright {
  width: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  .swap__btn {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    height: 100% !important;
    min-width: auto !important;
  }
}
</style>


// WEBPACK FOOTER //
// modules/Home/views/src/components/CardNota.vue